import React from "react";
import { ComponentStory, ComponentMeta } from "@storybook/react";
import Flex from "../Flex";
import Tooltip from "./Tooltip";

const commonArgs: React.ComponentProps<typeof Tooltip> = {
    tooltip: "Tooltip text"
};

export default {
    title: "common/Tooltip",
    component: Tooltip,
    args: commonArgs
} as ComponentMeta<typeof Tooltip>;

const Template: ComponentStory<typeof Tooltip> = args => {
    return (
        <Flex backgroundColor="background-secondary-25" height={500} justifyContent="center" alignItems="center">
            <Tooltip {...args}>
                <span>Hover to see the Tooltip</span>
            </Tooltip>
        </Flex>
    );
};

export const Default = Template.bind({});
